var React = require('react');

function Youtube32 (props) {
    return React.createElement("svg",props,[React.createElement("metadata",{"key":0}),React.createElement("defs",{"key":1},React.createElement("style",null,"\n      .cls-1 {\n        fill: #7e8082;\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("path",{"id":"Youtube_32","className":"cls-1","d":"M1643,57a16,16,0,1,1-16,16A16,16,0,0,1,1643,57Zm5.15,22.009h-10.31c-2.13,0-3.85-.629-3.85-3.825V70.83c0-3.387,1.72-3.824,3.85-3.824h10.31c2.12,0,3.85.055,3.85,3.824v4.354C1652,78.626,1650.27,79.009,1648.15,79.009Zm-7.16-9.022V76l6.02-3.508Z","transform":"translate(-1627 -57)","key":2})]);
}

Youtube32.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Youtube32;

Youtube32.default = Youtube32;
